/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Artist locker balance and claimable info for the coin
 * @export
 * @interface ArtistLocker
 */
export interface ArtistLocker {
    /**
     * Locker contract/pool address
     * @type {string}
     * @memberof ArtistLocker
     */
    address?: string;
    /**
     * Locked amount
     * @type {number}
     * @memberof ArtistLocker
     */
    locked?: number;
    /**
     * Unlocked amount
     * @type {number}
     * @memberof ArtistLocker
     */
    unlocked?: number;
    /**
     * Claimable amount
     * @type {number}
     * @memberof ArtistLocker
     */
    claimable?: number;
}

/**
 * Check if a given object implements the ArtistLocker interface.
 */
export function instanceOfArtistLocker(value: object): value is ArtistLocker {
    let isInstance = true;

    return isInstance;
}

export function ArtistLockerFromJSON(json: any): ArtistLocker {
    return ArtistLockerFromJSONTyped(json, false);
}

export function ArtistLockerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistLocker {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'locked': !exists(json, 'locked') ? undefined : json['locked'],
        'unlocked': !exists(json, 'unlocked') ? undefined : json['unlocked'],
        'claimable': !exists(json, 'claimable') ? undefined : json['claimable'],
    };
}

export function ArtistLockerToJSON(value?: ArtistLocker | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'locked': value.locked,
        'unlocked': value.unlocked,
        'claimable': value.claimable,
    };
}

